import React from 'react';
import Markdown from 'markdown-to-jsx';

import { ConstLink } from '@components';

import { ArticleContainer } from './styles';

interface IArticleProps extends React.PropsWithChildren<{}> {}

const Article = ({ children }: IArticleProps) => {
  if (typeof children !== 'string') {
    return <ArticleContainer>{children}</ArticleContainer>;
  }

  return (
    <ArticleContainer className="article">
      <Markdown
        options={{
          overrides: {
            ConstLink: {
              component: ConstLink,
            },
          },
        }}
      >
        {children}
      </Markdown>
    </ArticleContainer>
  );
};

export { Article };
